export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = 3